import { DataNode } from 'antd/es/tree';
import { useCallback, useRef } from 'react';
import { DefaultOptionType } from 'rc-tree-select/es/TreeSelect';

export interface OrganizationTreeProps {
  id?: number;
  level?: number;
  zoneName?: string;
  children?: OrganizationTreeProps[];
}

export interface TreeSelectOption {
  key: number;
  value: number;
  title: string;
  children?: TreeSelectOption[];
}

export interface TreeDataProps extends OrganizationTreeProps {
  rootNode?: boolean;
}

export interface CurrentDataProps extends OrganizationTreeProps {
  parentZoneName?: string;
  parentId?: number;
}

export const flattenTree = (nodes: DataNode[]): DataNode[] => {
  let result: DataNode[] = [];
  const traverse = (list: DataNode[]) => {
    list.forEach(node => {
      result.push({
        ...node,
        children: [],
      });
      if (node.children && node.children.length) {
        traverse(node.children as DataNode[]);
      }
    });
  };
  traverse(nodes);
  return result;
};

export const findPathToNode = (tree: DataNode[], targetKey: React.Key): React.Key[] => {
  const path: React.Key[] = [];
  const dfs = (nodes: DataNode[], currentPath: React.Key[]): boolean => {
    for (const node of nodes) {
      const newPath = [...currentPath, node.key];
      if (node.key === targetKey) {
        path.push(...newPath);
        return true;
      }
      if (node.children && dfs(node.children as DataNode[], newPath)) {
        return true;
      }
    }
    return false;
  };
  dfs(tree, []);
  return path;
};

export const getAllKeys = (treeData: any[]): React.Key[] => {
  const keys: React.Key[] = [];

  const traverse = (nodes: any[]) => {
    if (!nodes || !Array.isArray(nodes)) return;

    nodes.forEach(node => {
      // 如果有 children 且非空，说明是父节点，需要展开
      if (node.children && node.children.length > 0) {
        keys.push(node.key);
        traverse(node.children); // 递归
      }
    });
  };

  traverse(treeData);
  return keys;
};

export const transformToTreeSelectOptions = (nodes: OrganizationTreeProps[]): TreeSelectOption[] => {
  return nodes
    .filter(node => node.id != null && node.zoneName != null) // 过滤无效节点
    .map(node => ({
      key: node.id!,
      value: node.id!,
      title: node.zoneName!,
      children: node.children ? transformToTreeSelectOptions(node.children) : undefined,
    }));
};
